<template>
    <Teleport to="body">
        <transition appear v-on:after-enter="afterEnter" name="modal">
            <div class="modal modal-mask" :class="layoutTheme.class" :style="layoutTheme.style" ref="modal-mask" role="dialog" aria-modal="true">
                <div class="modal-wrapper" @click="$emit('close', $event)">
                    <div class="modal-container" :ref="`modal-container`" @click.stop>
                        <div v-if="$slots.header || hasLegacySlot('header')" class="modal-header">
                            <slot name="header">
                                <legacy-slot-renderer :nodes="legacySlots.header" />
                            </slot>
                        </div>
                        <div class="modal-body m-0 p-0">
                            <slot name="body">
                                <legacy-slot-renderer :nodes="bodyNodes" />
                            </slot>
                        </div>
                        <div class="modal-footer">
                            <slot name="footer">
                                <legacy-slot-renderer v-if="hasLegacySlot('footer')" :nodes="legacySlots.footer" />
                                <button v-else class="modal-default-button btn btn-secondary" @click="$emit('close')">
                                    {{ $tl("labels.form.actions.close") }}
                                </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<script>
import { Teleport } from "vue";
import { LAYOUT_THEME_KEY } from "../../../themes/manhattan";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { collectLegacyModalSlots, LegacySlotRenderer } from "./legacyModalSlots";

export default {
    inject: {
        layoutTheme: {
            from: LAYOUT_THEME_KEY,
            default: () => ({ class: null, style: {} }),
        },
    },
    computed: {
        bodyNodes() {
            if (this.hasLegacySlot("body")) {
                return this.legacySlots.body;
            }

            return this.legacySlots.default;
        },
        legacySlots() {
            return collectLegacyModalSlots(this.$slots);
        },
    },
    methods: {
        afterEnter() {
            const body = document.getElementsByTagName("BODY")[0];
            const modalMask = this.$refs["modal-mask"];

            if (document.getElementsByClassName("modal-container").length <= 1) {
                if (!body.classList.contains("w-100")) {
                    body.classList.add("w-100");
                }
            }

            if (modalMask instanceof HTMLElement) {
                disableBodyScroll(modalMask, { reserveScrollBarGap: true });
            }
        },
        hasLegacySlot(slotName) {
            return Array.isArray(this.legacySlots[slotName]) && this.legacySlots[slotName].length > 0;
        },
    },
    beforeUnmount() {
        const body = document.getElementsByTagName("BODY")[0];
        const modalMask = this.$refs["modal-mask"];

        if (document.getElementsByClassName("modal-container").length <= 1) {
            if (body.classList.contains("w-100")) {
                body.classList.remove("w-100");
            }
        }

        if (modalMask instanceof HTMLElement) {
            enableBodyScroll(modalMask);
        }
    },
    components: {
        LegacySlotRenderer,
        Teleport,
    },
};
</script>
